import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

export interface ModalSuccessData {
  msg?: string;
  title?: string;
  buttonText?: string;
  customClass?: string;
  customHTML?: string;
}

@Component({
selector: 'app-modal-success',
  imports: [TranslateModule, CommonModule],
  templateUrl: './modal-success.component.html',
  styleUrl: './modal-success.component.scss'
})
export class ModalSuccessComponent {
  private dialog = inject(MatDialogRef<ModalSuccessData>);
  public data = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    document.body.classList.add('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.removeAttribute('aria-hidden');
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.setAttribute('aria-hidden', 'true');
    }
  }

    beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }
  
  closeDialog(res?: any): void {
    this.beforeClose();
    this.dialog.close(res);
  }

}
